import { Tea } from '@fe/game-sdk';
import { type App, appConfig, cnAppConfig } from '@pst/app-config';
import { logger } from './logger';

declare global {
  interface Window {
    collectEvent: (event: string, options?: Record<string, unknown>) => void;
  }
}

// https://bytedance.larkoffice.com/sheets/Y22Ts5K8thmtArt7vkCcP8QCnje?sheet=eHYeiP&source_type=message&from=message
export interface BaseReportContext {
  language: string;
  /** 页面标题，根据特性需求设置，默认为当前页面的 title */
  page_text: string;
  web_name: '1';
  region: App['region'];
  [key: string]: any;
}

export class Reporter {
  instance?: Window['collectEvent'];
  context: BaseReportContext;
  appId: number;

  constructor(
    context: BaseReportContext,
    options: {
      activityId: number;
      title: string;
    },
  ) {
    this.context = context;
    const appId = context.region === 'cn' ? cnAppConfig.appId : appConfig.appId;
    this.appId = appId;
    Tea.initSendLogV3({
      app_id: appId,
      activity_id: options.activityId,
      zone: context.region,
      // 非必传参数，这个字段可以自定义通用参数，并且会在所有埋点事件里统一传参
      default_data: {
        page_text: options.title,
        activity_form: '0',
      },
    });

    if (window.collectEvent) {
      this.instance = window.collectEvent;
      this.instance('init', {
        app_id: appId,
        channel: context.region,
        configPersist: 2,
      });

      this.instance('start');
    }
  }

  sendSlardarError(content: string) {
    (window as any).slardarWeb?.('sendLog', {
      level: 'error',
      content: content,
    });
  }

  mergeContext(context: Partial<BaseReportContext>) {
    this.context = {
      ...this.context,
      ...context,
    };
  }

  sendEvent(event: string, params: Record<string, any>) {
    const commonParams = {
      /** 正式环境-'product'；沙箱环境-'sandbox'；BOE正式环境-'boe-product'；BOE沙箱环境-'boe-sandbox' */
      environment: 'product',
      aid: this.appId,
      url: window.location.href,
      /** 平台分流参数，根据游戏是国内还是海外写死；国内游戏："xuanwu"，海外游戏："xuanwu_overseas" */
      params_for_special: 'xuanwu_overseas',
      ...this.context,
    };
    if (event !== 'web_pagebrowse') {
      logger('event', params);
    }

    Tea.sendLogV3(event, {
      ...commonParams,
      ...params,
    });
  }

  push(event: string, params: Record<string, any>) {
    const commonParams = {
      /** 正式环境-'product'；沙箱环境-'sandbox'；BOE正式环境-'boe-product'；BOE沙箱环境-'boe-sandbox' */
      environment: 'product',
      aid: this.appId,
      url: window.location.href,
      /** 平台分流参数，根据游戏是国内还是海外写死；国内游戏："xuanwu"，海外游戏："xuanwu_overseas" */
      params_for_special: 'xuanwu_overseas',
      ...this.context,
    };
    if (event !== 'web_pagebrowse') {
      logger('event', params);
    }

    Tea.sendLogV3(event, {
      ...commonParams,
      ...params,
    });
  }
}
